import { Component, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractWidgetComponent } from '../abstract.widget';
import { WidgetConfiguration } from '../../../models/widget-configuration.model';
import { WidgetsHelper } from '../widgets.helper';

// @dynamic
@Component({
  selector: 'interface-widget-hello-world',
  template: `<ng-container *ngIf="!preview; else previewTemplate">
  <div class="jumbotron jumbotron-fluid">
    <div class="container">
      <h1 class="display-4">{{ title }}</h1>
      <p class="lead">{{ description }}</p>
    </div>
  </div>
</ng-container>
<ng-template #previewTemplate>
  <div draggable="true" (dragstart)="dragStartHandler($event)">
    <interface-widget-preview [data]="sanitizeData(true)"></interface-widget-preview>
  </div>
</ng-template>
`,
  styles: [`.jumbotron{height:100%}`],
})
export class HelloWorldWidgetComponent extends AbstractWidgetComponent implements OnChanges {
  @Input() item: any;
  constructor(protected ref: ChangeDetectorRef) {
    super(ref);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'configuration' || propName === 'item') {
        this.ref.detectChanges();
      }
    }
  }

  // Mandatory fields
  static get CONFIGURATION(): WidgetConfiguration[] {
    return [
      ...WidgetsHelper.defaultConfigurations,
      { key: 'title', name: 'Title', type: 'text' },
      { key: 'description', name: 'Description', type: 'text' },
    ];
  }

  static get OPTIONS() {
    return Object.assign(
      WidgetsHelper.defaultOptions,
    );
  }

  static get DESCRIPTION() {
    return 'Widget just to say hello.';
  }

  static get TITLE() {
    return 'Hello World';
  }

  static get ICON() {
    return 'fa fa-cog fa-4x';
  }
  // Mandatory fields end
}
